import React, { Component } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Login from '../components/Login';

export default class Homepage extends Component {
	render() {
        return (
            <div className='home'>
                <Header />
                <section>
                    <div className='jumbotron jumbotron-fluid py-5'>
                        <div className='container text-center py-5'>
                            <h1 className='display-4'>Welcome to Dweebs Chat</h1>
                        </div>
                        <div className='text-center'>
                            <Login />
                        </div>
                    </div>
                </section>
                <Footer />
            </div>
        )
	}
}